import Splide from '@splidejs/splide';

export const carousel = {
    init: () => {
        const $ = jQuery;

        const carousels = $('.image-carousel-splide');

        if (carousels.length === 0) {
            return false;
        }

        for (let i = 0; i < carousels.length; i++) {
            const carousel = new Splide(carousels[i], {
                type: 'loop',
                updateOnMove: true,
                perPage: 1,
                focus: 'center',
                pagination: false,
                mediaQuery: 'min',
                breakpoints: {
                    1600: {
                        gap: '10rem',
                    },
                    1440: {
                        gap: '8rem',
                    },
                    1200: {
                        gap: '6rem',
                    },
                    992: {
                        perPage: 3,
                        gap: '5rem'
                    },
                    768: {
                        perPage: 2,
                        gap: '3.5rem'
                    }
                }
            });

            carousel.mount();
        }
    }
}